import { render, staticRenderFns } from "./EmployeeLayout.vue?vue&type=template&id=67970380"
import script from "./EmployeeLayout.vue?vue&type=script&lang=ts"
export * from "./EmployeeLayout.vue?vue&type=script&lang=ts"
import style0 from "./EmployeeLayout.vue?vue&type=style&index=0&id=67970380&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VDivider})
